export const conciergeVideoThumbnail = '/concierge-video-thumbnail.png';

export const conciergeVideoURL =
  'https://getbezel.mo.cloudinary.net/static/concierge-video-v1.mp4?cld-content-marker=jit';
